// SPDX-License-Identifier: AGPL-3.0-or-later

export const DEFAULT_MESSAGE_GUTTER_PX = 16;
